import { render, staticRenderFns } from "./MailViewDlg.vue?vue&type=template&id=52cce727&scoped=true"
import script from "./MailViewDlg.vue?vue&type=script&lang=js"
export * from "./MailViewDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cce727",
  null
  
)

export default component.exports